import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-login-external',
  templateUrl: './login-external.component.html',
  styleUrls: ['./login-external.component.scss']
})
export class LoginExternalComponent  {
  show = true;

  logoCidi = 'assets/img/cidi.png';
  logoArca = 'assets/img/arca.png';

  afipData = {
      token: 'lBBjlTi7SyaxlziKJAUHW377WraC63pS',
      url_ftago: `${environment.afip.redirecTo}`
  };

  afipEncoded = btoa(JSON.stringify(this.afipData));

  cidiUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.cidi.url);
  arcaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.afip.url}?${this.afipEncoded}`);

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  cidiLogin() {
    this.show = false;
  }

}
